import api from '../../services/api';
import { AuditEvent } from '../../types'; // Define the AuditEvent type based on the API response
import Cookies from 'js-cookie';

export const fetchAuditTrail = async (token: string): Promise<AuditEvent[]> => {
  try {
    const response = await api.get(`/events`);

    if (!(response.status >= 200) || response.status <= 300) {
      return response.data;
    }
    else {
      throw new Error("Failed to fetch audit trail");
    }
  } catch (error: any) {
    console.error('Error fetching audit trail:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch audit trail.');
  }


};
